import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs/Observable';

import { SpinnerService } from './spinner.service';
import { IPerson } from "../model/person";
import { IInvoicingService } from "../model/invoicing-service";

@Injectable()
export class PersonService {

   /**
   *
   * @type {string}
   */
   private personUrl = environment.apiUrl + '/v1/person';

  /**
   *
   * @type {string}
   */
  private personUrlPreferences = environment.apiUrl + '/v1/person/authenticated/preferences';

  /**
   *
   * @param {HttpClient} http
   * @param {SpinnerService} spinnerService
   */
  constructor(private http: HttpClient,
              private spinnerService: SpinnerService) {
  }


  /**
   * Devuelve el usuario logueado, para el caso de login a traves de clave
   */
  getPersonAuthenticated(): Observable<IPerson> {
    this.spinnerService.setSpinner(true);
    return this.http.get(this.personUrl + '/authenticated')
      .map(res => {
        this.spinnerService.setSpinner(false);
        return res as IPerson;
      })
      .catch(error => {
        this.spinnerService.setSpinner(false);
        return Observable.throw(error);
      });
  }

  /**
   *
   * @param person
   * @param defaultInvoicingService
   * @returns {Observable<IPerson>}
   */
  setPreference(person: IPerson, defaultInvoicingService: IInvoicingService): Observable<IPerson> {
    this.spinnerService.setSpinner(true);

    if (person.preferences === undefined) {
      return this.http.post(this.personUrlPreferences, defaultInvoicingService)
        .map(res => {
          this.spinnerService.setSpinner(false);
          return res as IPerson;
        })
        .catch(error => {
          this.spinnerService.setSpinner(false);
          return Observable.throw(error);
        });
    } else {
      return this.http.patch(this.personUrlPreferences, defaultInvoicingService)
        .map(res => {
          this.spinnerService.setSpinner(false);
          return res as IPerson;
        })
        .catch(error => {
          this.spinnerService.setSpinner(false);
          return Observable.throw(error);
        });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/person.service.ts